import React, { useEffect, useState } from 'react';
import styled from "styled-components";
const OuterContainer = styled.div.withConfig({
  displayName: "AutoScaleContainer__OuterContainer",
  componentId: "sc-ssrjuv-0"
})(["position:fixed;top:0;bottom:0;left:0;right:0;"]);
const CanvasContainer = styled.div.withConfig({
  displayName: "AutoScaleContainer__CanvasContainer",
  componentId: "sc-ssrjuv-1"
})(["display:block;position:relative;width:", "px;height:", "px;transform-origin:top left;overflow:hidden;"], props => props.width, props => props.height);
/**
 * Container that makes sure that its contents are completely visible. Keeps the width x height aspect ratio.
 */

export const AutoScaleContainer = ({
  width,
  height,
  className,
  children
}) => {
  const [containerElement, setContainerElement] = useState(null);
  useEffect(() => {
    if (!containerElement) return undefined;

    const onResize = () => {
      /*
      const browserWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const browserHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      */
      const {
        parentElement
      } = containerElement;
      const availableWidth = parentElement.clientWidth;
      const availableHeight = parentElement.clientHeight;
      const scale = Math.min(availableWidth / width, availableHeight / height);
      /*
      // Don't scale up
      if (scale > 1)
          scale = 1;
      */

      containerElement.setAttribute("style", "transform: scale(" + scale + ")");
    };

    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [containerElement, width, height]);
  return /*#__PURE__*/React.createElement(OuterContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(CanvasContainer, {
    width: width,
    height: height,
    ref: setContainerElement
  }, children));
};